import { Component, OnInit,Input } from '@angular/core';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import{ LoopBackAuth, pensumService} from '../../services/api-rest.service';
import{MessageService} from '../../services/message.service';

@Component({
  selector: 'app-modal-asignar-actividades',
  templateUrl: './modal-asignar-actividades.component.html',
  styleUrls: ['./modal-asignar-actividades.component.css'],
  providers:[LoopBackAuth, pensumService, MessageService]
})
export class ModalAsignarActividadesComponent implements OnInit {
  @Input() activos 
  @Input() pensum
  seleccionados: string
  spinner:boolean = true
  constructor(
    public activeModal: NgbActiveModal,
    public pensumService: pensumService
    ) { }

  ngOnInit() {

  }
  
  asignarCadena(event){
    this.seleccionados = event
  }

  save(){
    this.spinner = false
    this.pensumService.asignarInsumos(this.seleccionados,this.pensum).subscribe(
      item =>{
        if(item){
          this.activeModal.close(this.seleccionados)
        }
        this.spinner =true
      }
    )
    
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal-asignar-actividades/modal-asignar-actividades.component.ts